import React, { useContext, useEffect } from "react";
import Col from "../../../UIcomponent/Column";
import LocalContext from "../../../Context/LocalContetxt";
import "./DashboardProfile.scss";
import { Rate } from "../../../UIcomponent/Rate";
import AvatarDefault from "../../../Assets/images/AvatarDefault.jpg";
import Urls from "../../../Utility/Urls";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import StyledAvatar from "../../../UIcomponent/StyledAvatar";
const DashboardProfile = (props) => {
  const lang = useContext(LocalContext).lang;
  const config = useContext(LocalContext).config;
  const role = config && config.role;
  const { avatar, firstName, lastName, reviewStats, theme, credit } = props;
  const rate = reviewStats ? reviewStats.Rate : 0;
  useEffect(() => {}, [reviewStats]);

  return (
    <Col
      className="l__DashboardProfile"
      xl={24}
      lg={24}
      md={24}
      sm={24}
      xs={24}
      lang={lang}
    >
      <Col
        className="c__DashboardProfile__Avatar"
        xl={8}
        lg={8}
        md={6}
        sm={6}
        xs={12}
      >
        <StyledAvatar
          className="o__DashboardProfile__Avatar"
          source={
            avatar && avatar !== "" ? Urls.avatar() + avatar : AvatarDefault
          }
        ></StyledAvatar>
      </Col>
      <Col
        className="c__DashboardProfile__Info"
        xl={15}
        lg={15}
        md={14}
        sm={24}
        xs={24}
      >
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={18}
          xs={18}
          className="o__DashboardProfile__Info__Name"
        >
          {firstName + " " + lastName}
        </Col>
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={18}
          xs={18}
          className="o__DashboardProfile__Info__ID"
        >
          <Col>شناسه کاربری</Col>
          <Col>{config?.userID}</Col>
        </Col>
        {role === "Teacher" && (
          <Col
            xl={21}
            lg={24}
            md={24}
            sm={18}
            xs={18}
            className="c__DashboardProfile__Info__Rate"
            style={{
              border: role === "Student" && "none",
            }}
          >
            <Col
              // xl={12} lg={12} md={12} sm={12} xs={12}
              className="o__DashboardProfile__Info__Rate"
            >
              {role === "Teacher" && (
                <>
                  {
                    rate > 0 && (
                      <>
                        <Col className="o__DashboardProfile__Info__Rate__Value">
                          {rate.toString().length > 3 ? rate.toFixed(1) : rate}
                        </Col>
                        <Rate
                          value={rate}
                          allowHalf={true}
                          allowClear={false}
                          disabled={true}
                          icon={<StarRoundedIcon fontSize="15" />}
                          style={{
                            direction:
                              lang === "fa" || lang === "ar" ? "ltr" : "rtl",
                            color: theme.warning,
                            opacity: 1,
                            fontSize: "15px",
                          }}
                          size="larg"
                        />
                      </>
                    )
                    //         :
                    //         <Col
                    //             sm={12} xs={12}>
                    //             <StyledButton
                    //                 onClick={() => DemoClass()}
                    //                 primary
                    //                 rounded
                    //                 style={{
                    //                     border: '1px solid white',
                    //                     // width: '210px'
                    //                 }}
                    //             >
                    //                 کلاس دمو
                    // </StyledButton>
                    // </Col>
                  }
                </>
              )}
            </Col>
          </Col>
        )}
        <Col
          sm={23}
          xs={24}
          className="c__DashboardProfile__Info__RateCredit--RES"
          style={{
            borderLeft: role === "Student" && "none",
          }}
        >
          {role === "Teacher" && (
            <>
              {rate > 0 && (
                <>
                  <Col
                    sm={12}
                    xs={12}
                    className="o__DashboardProfile__Info__RateCredit__Rate--RES"
                  >
                    <Col className="o__Info__RateCredit__Rate__Title--RES">
                      امتیاز
                      {rate.toString().length > 3 ? rate.toFixed(1) : rate}
                    </Col>
                    <Col className="o__Info__RateCredit__Rate__Star--RES">
                      <Rate
                        precision={0.1}
                        value={rate}
                        allowHalf={true}
                        disabled={true}
                        readOnly={true}
                        icon={<StarRoundedIcon fontSize="inherit" />}
                        style={{
                          direction:
                            lang === "fa" || lang === "ar" ? "ltr" : "rtl",
                          color: theme.warning,
                          opacity: 1,
                        }}
                      />
                    </Col>
                  </Col>
                </>
              )}
            </>
          )}
          <Col
            sm={rate === 0 ? 22 : 12}
            xs={rate === 0 ? 22 : 12}
            className="o__DashboardProfile__Info__RateCredit__Credit--RES"
            style={{
              borderRight: (role === "Student" || rate === 0) && "none",
              flexDirection: rate === 0 && "row",
            }}
          >
            <Col
              sm={rate > 0 ? 24 : 12}
              xs={rate > 0 ? 24 : 12}
              className="o__Info__RateCredit__Credit__Title--RES"
            >
              موجودی کیف پول
            </Col>
            <Col
              sm={rate > 0 ? 24 : 12}
              xs={rate > 0 ? 24 : 12}
              className="o__Info__RateCredit__Credit__Value--RES"
            >
              {credit && (credit / 10).toLocaleString(lang)} تومان
            </Col>
          </Col>
        </Col>
      </Col>
    </Col>
  );
};

export default DashboardProfile;
